import clientUtils from '../../utils/clientUtils';

const AssetDuration = ({ item }) => {
  const durationForDisplay = () => {
    // console.log('item', item);
    if (item && item.durationString !== undefined && item.durationString !== null) {
      return clientUtils.formatDuration(item.durationString);
    }
    if (item && item.duration !== undefined && item.duration !== null) {
      return clientUtils.formatDuration(item.duration);
    }
    return null;
  };
  return <span>{durationForDisplay()}</span>;
};

export default AssetDuration;
